import React, { memo } from 'react';
import { Loader2 } from 'lucide-react';

const LoadingSpinner = memo(() => (
    <div className="loading-spinner">
  <Loader2 size={32} className="spin" color="var(--accent-color)" />
      <span className="loading-text">Loading...</span>
    </div>
  ));

export default LoadingSpinner;